<template>
  <div v-if="pageFrameStatus === 0" class="layout-wrap">
    <template v-if="$route.meta.noTabFrame">
      <LayoutMainFixed v-if="$route.meta.layout === 'fixed'"></LayoutMainFixed>
      <LayoutFluid v-else-if="$route.meta.layout === 'fluid'"></LayoutFluid>
      <LayoutMain v-else-if="$route.meta.layout === 'main'"></LayoutMain>
    </template>
    <template v-else-if="pageFrame === '1'">
      <LayoutTab ref="layoutTab"></LayoutTab>
    </template>
    <template v-else>
      <LayoutMainFixed v-if="$route.meta.layout === 'fixed'"></LayoutMainFixed>
      <LayoutFluid v-else-if="$route.meta.layout === 'fluid'"></LayoutFluid>
      <LayoutMain v-else-if="$route.meta.layout === 'main'"></LayoutMain>
    </template>
  </div>
</template>

<script>
import LayoutMainFixed from './layout-main-fixed.vue'
import LayoutFluid from './layout-fluid.vue'
import LayoutMain from './layout-main'
import LayoutTab from './layout-tab'
import {mapState} from 'vuex'
import initSyRouter from 'fe-coms/components/business/page-tab-frame/init-syrouter'

export default {
  name: 'layout-full',
  components: {
    LayoutTab,
    LayoutMainFixed,
    LayoutFluid,
    LayoutMain
  },
  computed: {
    ...mapState({
      pageFrame: state => state.user.pageFrame,
      isAuth: state => state.user.isAuth,
      pageFrameStatus: state => state.user.pageFrameStatus
    })
  },
  watch: {
    $route: {
      handler: async function (current, prev) {
        if (this.isAuth) {
          await this.$store.dispatch('initPageFrame')
        }
        if (this.pageFrame === '1' || this.$route.meta.layout === 'fluid') {
          this.$store.dispatch('initMenuList')
        }
        if (prev && this.pageFrame === '1' && !current?.meta.noTabFrame && prev?.meta.noTabFrame) {
          this.$nextTick(() => {
            // console.log('setPreRoute', current, prev, this.$refs['layoutTab'])
            this.$refs.layoutTab?.setPreRoute(current, prev)
          })
        }
      },
      immediate: true
    }
  },
  async created () {
    initSyRouter(this)
    // window.fe.vue.prototype.$syRouter = {
    //   back: () => {
    //     this.pageFrame === '1' ? this.$refs.layoutTab?.back() : this.$router.back()
    //   },
    //   open: (path, strWindowName, strWindowFeatures) => {
    //     if (this.pageFrame === '1') {
    //       this.$router.push(path)
    //     } else {
    //       let { href } = this.$router.resolve({path})
    //       return window.open(href, strWindowName, strWindowFeatures)
    //     }
    //   },
    //   reset () {
    //     if (this.pageFrame === '1') {
    //       this.$refs.layoutTab?.reset()
    //     }
    //   }
    // }
    // if (this.isAuth) {
    //   await this.$store.dispatch('initPageFrame')
    // }
    // if (this.pageFrame === '1' || this.$route.meta.layout === 'fluid') {
    //   this.$store.dispatch('initMenuList')
    // }
  }
}
</script>

<style lang="scss" scoped>
.layout-wrap {
  height: 100%;
}
</style>
<style>
@media screen and (min-width: 2800px) {
  html {
    zoom: 1.8;
  }
}
</style>
